import GetWidgetRegistrationMarketingQuestionsDefinitionRequestModelBase from '../_generated/modelBases/get-widget-registration-marketing-questions-definition-request-model-base';

export default class GetWidgetRegistrationMarketingQuestionsDefinitionRequestModel extends GetWidgetRegistrationMarketingQuestionsDefinitionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
